import { useEffect, useState } from "react";
import langProductAll from "../../api/langProductAll";
import { useTranslation } from "react-i18next";

const ProductLang = () => {
  const { i18n } = useTranslation();
  const [product, setProduct] = useState(null);

  // Sadece 'en', 'tr', 'ar' olacak şekilde kısalt
  const lang = i18n.language.split("-")[0];

  useEffect(() => {
    const fetchProduct = async () => {
      const data = await langProductAll();
      setProduct(data);
    };
    fetchProduct();
  }, []);

  if (!product || !product.translations || !product.translations[lang]) {
    return <div>Yükleniyor...</div>;
  }

  const content = product.translations[lang];

  return (
    <div>
      <h1>{content.name}</h1>
      <p>{content.description}</p>
      <p>{content.availability}</p>
      <p>{content.color}</p>
    </div>
  );
};

export default ProductLang;
